import { styled, keyframes } from '@uhg-abyss/web/tools/styled';
const roll = keyframes({
  to: {
    backgroundPosition: '960px 0,  100px 50px, 100px 120px',
  }
})
  ;
const pemRoll = keyframes({
  to: {
    backgroundPosition: '960px 0, 50% 50px, 50% 120px',
  }
});
const rollLarge = keyframes({
  to: {
    backgroundPosition: '10px 125px, 100% 0, /* move highlight to right */ 120px 100px, 120px 200px, 120px 300px, 120px 400px'
  }
});
const rollWC = keyframes({
  to: {
    backgroundPosition: '10px 125px, 100% 0, /* move highlight to right */ 0px 100px, 0px 200px, 0px 300px, 0px 400px'
  }
});
const shine = keyframes({
  to: {
    backgroundPosition: '10px 125px, 100% 0, /* move highlight to right */ 120px 100px, 120px 150px, 120px 200px, 120px 250px'  }
});
export const Loader = styled('div', {
  width: '100%',
  display: 'block',
  overflowX: 'hidden',
  ".skeleton-mid": {
    width: '960px',
    maxWidth: '100%',
    height: ' 219px',
    backgroundColor: 'white',

    backgroundImage: `linear-gradient(
                100deg,
                rgba(255, 255, 255, 0),
                rgba(255, 255, 255, 0.5) 50%,
                rgba(255, 255, 255, 0) 80%
              ),
              linear-gradient(lightgray 20px, transparent 0), linear-gradient(lightgray 20px, transparent 0)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '50px 219px, /* highlight */ 700px 200px, 700px 200px',
    backgroundPosition: '0 0, /* highlight */ 100px 50px, 100px 120px',
    animation: `${roll} 1s  infinite`
  },
  '.skeleton-mid.pem-summary-skeleton': {
    animation: `${pemRoll} 1s infinite`,
  },
  ".skeleton-mid-large": {
    width: '960px',
    maxWidth: '100%',
    backgroundColor: 'white',
    backgroundImage: `radial-gradient(circle 50px at 50px 50px, lightgray 0, transparent 0),
    linear-gradient(100deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 80%),
    linear-gradient(lightgray 20px, transparent 0), linear-gradient(lightgray 20px, transparent 0),
    linear-gradient(lightgray 20px, transparent 0), linear-gradient(lightgray 20px, transparent 0)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100px 200px, /* circle */ 50px 519px, /* highlight */ 700px 200px, 700px 200px, 700px 200px, 700px 200px',
    backgroundPosition: '10px 125px, /* circle */ 0 0, /* highlight */ 120px 100px, 120px 200px, 120px 300px, 120px 400px',
    animation: `${rollLarge} 1.5s infinite`,
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)', // Add this line
    borderRadius: '4px'
  },
  '.wc-skeleton': {
    width: '100%',
    backgroundColor: 'white',
    backgroundImage: `radial-gradient(circle 50px at 50px 50px, lightgray 0, transparent 0),
    linear-gradient(100deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 80%),
    linear-gradient(lightgray 20px, transparent 0), linear-gradient(lightgray 20px, transparent 0),
    linear-gradient(lightgray 20px, transparent 0), linear-gradient(lightgray 20px, transparent 0)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100px 200px, /* circle */ 50px 519px, /* highlight */ 700px 200px, 700px 200px, 700px 200px, 700px 200px',
    backgroundPosition: '10px 125px, /* circle */ 0 0, /* highlight */ 0px 100px, 0px 200px, 0px 300px, 0px 400px',
    animation: `${rollWC} 1.5s infinite`,
    boxShadow: 'none',
  },
  '.skeleton-small': {
    margin: 'auto',
    width: '468px',
    maxWidth: '100%',
    height: '356px',
    backgroundColor: 'white',
    backgroundImage: `radial-gradient(circle 50px at 50px 50px, lightgray 99%, transparent 0),
    linear-gradient(100deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 80%),
    linear-gradient(lightgray 20px, transparent 0), linear-gradient(lightgray 20px, transparent 0),
    linear-gradient(lightgray 20px, transparent 0), linear-gradient(lightgray 20px, transparent 0)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100px 200px, /* circle */ 50px 356px, /* highlight */ 150px 200px, 250px 200px, 300px 200px, 250px 200px',
    backgroundPosition: '10px 125px, /* circle */ 0 0, /* highlight */ 120px 100px, 120px 150px, 120px 200px, 120px 250px',
    animation: `${shine} 1s infinite`,
  },
  '.skeleton-xs': {
    width: '380px',
    maxWidth: '100%',
    height: '210px',
    backgroundColor: 'white',

    backgroundImage: `linear-gradient(
                100deg,
                rgba(255, 255, 255, 0),
                rgba(255, 255, 255, 0.5) 50%,
                rgba(255, 255, 255, 0) 80%
              ),
              linear-gradient(lightgray 20px, transparent 0), linear-gradient(lightgray 20px, transparent 0)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '50px 219px, /* highlight */ 700px 200px, 700px 200px',
    backgroundPosition: '0 0, /* highlight */ 100px 50px, 100px 120px',
    animation: `${roll} 1s  infinite`
  },
})